module.exports = __webpack_public_path__ + "static/img/playstore.71bb620d.svg";